import React from 'react';

const Faq = () => {

  const happiestWorkplaceData = {
    sections: [
      {
        id: 1,
        title: "What is the Happiest Workplaces Award?",
        description:
          "The Happiest Workplaces Award honors organizations that truly invest in their employees' happiness, mental well-being, and work-life balance. This award is based on real employee feedback, workplace policies, and expert analysis to identify companies where employees feel valued, fulfilled, and motivated every day.",
        criteria: [
          "Promote work-life balance & flexibility",
          "Offer mental health support & employee well-being programs",
          "Have a positive workplace culture & high employee satisfaction",
          "Provide career growth opportunities and meaningful work",
        ],
        callToAction: "Apply Now",
      },
      {
        id: 2,
        title: "Why Winning This Award Matters?",
        stats: "90% of job seekers consider workplace happiness when choosing a company.",
        benefits: [
          "Attract & Retain Top Talent – Become a top employer of choice",
          "Boost Employee Engagement – Happier employees lead to higher productivity",
          "Increase Brand Trust – Gain recognition as a leading workplace",
          "Get Featured in Media – Gain exposure in HR publications and industry reports",
        ],
        pastResults: [
          "40% increase in job applications",
          "25% boost in employee morale",
          "30% higher retention rates",
        ],
        callToAction: "Nominate Your Company",
      },
      {
        id: 3,
        title: "How to Apply for the Happiest Workplaces Award 2024?",
        steps: [
          "Submit Your Application - Click the 'Apply Now' button and fill out the nomination form.",
          "Employee Survey & Workplaces Evaluation - We gather anonymous employee feedback and review workplace policies.",
          "Final Evaluation & Winner Announcement - Our expert panel evaluates all data and announces the winners!",
        ],
        deadline: "[Insert Date]",
        announcement: "[Insert Date]",
        eligibility: [
          "Open to companies of all sizes across India",
          "Must have at least 50 employees",
          "Companies must complete the employee happiness survey",
        ],
        callToAction: "Apply Now",
      },
      {
        id: 4,
        title: "Meet the Past Winners – Happiest Workplaces in India 2023",
        winners: {
          largeCompanies: [
            { name: "Google India", award: "Best for Employee Perks & Mental Health Support" },
            { name: "Tata Consultancy Services (TCS)", award: "Best for Work-Life Balance" },
          ],
          midSizedCompanies: [
            { name: "Zoho", award: "Best for Employee Well-Being Initiatives" },
            { name: "Freshworks", award: "Best for Learning & Development Opportunities" },
          ],
          startups: [
            { name: "Razorpay", award: "Best for Company Culture & Employee Growth" },
            { name: "Zerodha", award: "Best for Remote Work & Flexibility" },
          ],
        },
        callToAction: "Apply Now",
      },
    ],
  };

  return (
    <>

      {happiestWorkplaceData.sections.map((section, index) => (
        <div key={section.id} className="mb-8">
          <h1 className="text-2xl font-bold mb-4">{index + 1 + "."} {section.title}</h1>
          {section.description && <p className="mb-4">{section.description}</p>}
          {section.criteria && (
            <ul className="list-disc pl-6">
              {section.criteria.map((item, index) => (
                <li key={index} className="text-[#212121]">{item}</li>
              ))}
            </ul>
          )}
          {section.benefits && (
            <ul className="list-disc pl-6">
              {section.benefits.map((item, index) => (
                <li key={index} className="text-[#212121]">{item}</li>
              ))}
            </ul>
          )}
          {section.steps && (
            <ul className="list-disc pl-6">
              {section.steps.map((step, index) => (
                <li key={index} className="text-[#212121]">{step}</li>
              ))}
            </ul>
          )}
          {section.winners && (
            <div>
              <h2 className="text-lg font-semibold mt-4">Past Winners:</h2>
              {Object.entries(section.winners).map(([category, winners]) => (
                <div key={category} className="mt-2">
                  <h3 className="text-md font-semibold">{category.replace(/([A-Z])/g, ' $1')}</h3>
                  <ul className="list-disc pl-6">
                    {winners.map((winner, index) => (
                      <li key={index} className="text-gray-600">
                        {winner.name} – {winner.award}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
          {/* <div className="text-center mt-4">
            <button className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow-lg">
              {section.callToAction}
            </button>
          </div> */}
        </div>
      ))}

    </>

  );
};

export default Faq;